<template>
    <div class="">
        <div class="top_title">
            <div class="top_back_home" @click="backToindex">
                <img src="../../../public/images/home.png" alt="" />
                <p>返回首页</p>
            </div>
            <div class="title">
                批次管理
            </div>
        </div>
        <div class="main">
            <div class="top_title">
                <div class="left">
                    批次列表（35）
                </div>
                <div class="right">
                    <div class="itt">
                        <img src="../../../public/images/add.png" alt="" />
                        <p>商品管理</p>
                    </div>
                    <div class="itt">
                        <img src="../../../public/images/set.png" alt="" />
                        <p>新建批次</p>
                    </div>
                </div>
            </div>
            <div class="pici_list">
                <div class="pici_item">
                    <div class="pici_item_top">
                        <div class="left">
                            <div class="ll">
                                903车，赵亮拉205只，352500元已打款清账，1月18日卖
                            </div>
                            <div class="rr">
                                置顶
                            </div>
                        </div>
                        <div class="right">
                            <div class="itt zd_qx">
                                <img src="../../../public/images/zd_qx.png" alt="" />
                                <p>取消置顶 </p>
                            </div>
                            <div class="itt exit">
                                <img src="../../../public/images/exit_icon.png" alt="" />
                                <p>编辑</p>
                            </div>
                        </div>
                    </div>
                    <div class="pici_item_fei">
                        <div class="pici_item_fei_tit">
                            费用合计
                        </div>
                        <div class="pici_item_fei_box">
                            <div class="itt">
                                <p>商品费用</p>
                                <h3>¥240768</h3>
                            </div>
                            <div class="itt">
                                <p>运输费用</p>
                                <h3>¥2800</h3>
                            </div>
                            <div class="itt">
                                <p>手续费用</p>
                                <h3>¥1000</h3>
                            </div>
                            <div class="itt">
                                <p>其他费用</p>
                                <h3>0</h3>
                            </div>
                            <div class="itt">
                                <p>总成本</p>
                                <h3>¥244568</h3>
                            </div>
                        </div>
                    </div>

                    <div class="zhedie">
                        <div class="zhedie_box slide-container" ref="slideContent">
                            <div class="zhedie_tit">
                                商品明细
                            </div>
                            <div class="zhedie_con">
                                <div class="zhedie_con_tit">
                                    <p>商品</p>
                                    <p>数量</p>
                                    <p>总重量</p>
                                    <p>单价</p>
                                    <p>总金额</p>
                                </div>
                                <div class="zhedie_con_body">
                                    <div class="itt">
                                        <p>羊肉(公斤)羊肉(公斤)羊肉(公斤)羊肉(公斤)羊肉(公斤)</p>
                                        <p>161只</p>
                                        <p>18240斤</p>
                                        <p>13.2元/斤</p>
                                        <p>240768</p>
                                    </div>
                                    <div class="itt">
                                        <p>羊肉(公斤)</p>
                                        <p>161只</p>
                                        <p>18240斤</p>
                                        <p>13.2元/斤</p>
                                        <p>240768</p>
                                    </div>
                                    <div class="itt">
                                        <p>羊肉(公斤)</p>
                                        <p>161只</p>
                                        <p>18240斤</p>
                                        <p>13.2元/斤</p>
                                        <p>240768</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="slide">
                            <div class="tem slidedown" @click="slideDown" v-if="!isExpanded">
                                <img src="../../../public/images/slidedown.png" alt="" />
                                展开
                            </div>
                            <div class="tem slideup" @click="slideDown" v-if="isExpanded">
                                <img src="../../../public/images/slideup.png" alt="" />
                                收起
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                isExpanded: false, // 用于跟踪展开/收起状态
                animationDuration: 300 // 动画持续时间（毫秒）
            }
        },
        computed: {

        },
        methods: {
            //返回首页
            backToindex() {
                this.$router.push({
                    path: '/',
                })
            },

            slideDown() {
                const element = this.$refs.slideContent;

                // 重置样式以准备动画
                element.style.height = '0';
                element.style.overflow = 'hidden';
                element.style.display = 'block';

                // 获取内容的实际高度
                const contentHeight = element.scrollHeight + 'px';

                // 开始动画
                requestAnimationFrame(() => {
                    element.style.transition = `height ${this.animationDuration}ms ease-in-out`;
                    element.style.height = contentHeight;
                    console.log("11111");
                    // 动画结束后移除过渡属性并设置为auto
                    setTimeout(() => {
                        element.style.height = 'auto';
                        this.isExpanded = true; // 更新状态
                        console.log("22222");
                    }, this.animationDuration);
                });
            },

            slideUp() {
                const element = this.$refs.slideContent;

                // 获取当前高度
                const currentHeight = window.getComputedStyle(element).height;

                // 设置为具体像素值以准备动画
                element.style.height = currentHeight;
                element.style.overflow = 'hidden';

                // 强制重绘
                requestAnimationFrame(() => {
                    element.style.transition = `height ${this.animationDuration}ms ease-in-out`;
                    element.style.height = '0';
                    console.log("333");
                    // 动画结束后隐藏元素
                    setTimeout(() => {
                        element.style.display = 'none';
                        this.isExpanded = false; // 更新状态
                        console.log("444");
                    }, this.animationDuration);
                });
            }
        }
    }
</script>

<style lang="less" scoped>
    .main {
        padding: 0 20px;
        box-sizing: border-box;
        margin-top: 20px;
        .top_title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            background: #FFFFFF;
            border-radius: 8px 8px 8px 8px;
            padding: 20px;
            margin-bottom: 20px;
            box-sizing: border-box;

            .left {
                padding-left: 8px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 18px;
                color: #36363A;
                line-height: 28px;
                position: relative;
            }

            .left::after {
                content: '';
                display: block;
                width: 4px;
                height: 17px;
                background: #3F72FF;
                border-radius: 12px 12px 12px 12px;
                position: absolute;
                left: 0;
                top: 6px;
            }

            .right {
                display: flex;
                align-items: center;

                .itt {
                    display: flex;
                    align-items: center;
                    cursor: pointer;

                    img {
                        display: block;
                        width: 16px;
                        height: 16px;
                        margin-right: 4px;
                    }

                    p {
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 16px;
                        color: #3F72FF;
                    }
                }

                .itt:first-child {
                    margin-right: 20px;
                }
            }
        }

        .pici_list {
            .pici_item {
                background: #FFFFFF;
                border-radius: 8px 8px 8px 8px;
                padding: 20px;
                margin-bottom: 20px;

                .pici_item_top {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    border-bottom: 1px solid #F0F0F0;

                    .left {
                        display: flex;
                        align-items: center;

                        .ll {
                            font-family: PingFang SC, PingFang SC;
                            font-weight: 500;
                            font-size: 16px;
                            color: #36363A;
                            line-height: 38px;
                        }

                        .rr {
                            font-family: PingFang SC, PingFang SC;
                            font-weight: 400;
                            font-size: 12px;
                            color: #FFFFFF;
                            background: #FF7700;
                            border-radius: 4px 4px 4px 4px;
                            margin-left: 4px;
                            padding: 0 4px;
                            line-height: 24px;
                        }
                    }

                    .right {
                        display: flex;
                        align-items: center;

                        .itt {
                            display: flex;
                            align-items: center;
                            margin-left: 16px;
                            color: #333;

                            img {
                                display: block;
                                width: 16px;
                                height: 16px;
                                margin-right: 4px;
                            }

                            p {
                                font-family: PingFang SC, PingFang SC;
                                font-weight: 400;
                                font-size: 14px;
                                line-height: 22px;
                            }
                        }

                        .itt.zd_qx {
                            color: #FF7700;
                        }

                        .itt.exit {
                            color: #3F72FF;
                        }

                        .itt.zd_qx {
                            color: #FF7700;
                        }

                        .itt.zd_qx {
                            color: #FF7700;
                        }

                        .itt.zd_qx {
                            color: #FF7700;
                        }

                        .itt.zd_qx {
                            color: #FF7700;
                        }
                    }
                }

                .pici_item_fei {
                    .pici_item_fei_tit {
                        font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #36363A;
                        line-height: 22px;
                        padding: 12px 0 8px 0;
                    }

                    .pici_item_fei_box {
                        padding: 12px;
                        background: #F5F6FC;
                        display: flex;
                        align-items: center;

                        .itt {
                            flex: 1;

                            p {
                                font-family: PingFang SC, PingFang SC;
                                font-weight: 400;
                                font-size: 14px;
                                color: #9B9CA1;
                                line-height: 22px;
                            }

                            h3 {
                                font-family: PingFang SC, PingFang SC;
                                font-weight: 400;
                                font-size: 14px;
                                color: #36363A;
                                line-height: 22px;
                                margin-top: 4px;
                            }
                        }
                    }
                }

                .zhedie {
                    .zhedie_box {
                        overflow: hidden;
                        display: none;
                        transition: height 0.3s ease-in-out;

                        .zhedie_tit {
                            font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
                            font-weight: 400;
                            font-size: 14px;
                            color: #36363A;
                            line-height: 22px;
                            padding: 12px 0 8px 0;
                        }

                        .zhedie_con {
                            .zhedie_con_tit {
                                display: flex;
                                align-items: center;
                                background: #F5F6FC;

                                p {
                                    flex: 1;
                                    font-family: PingFang SC, PingFang SC;
                                    font-weight: 400;
                                    font-size: 14px;
                                    color: #9B9CA1;
                                    line-height: 38px;
                                    padding: 0 6px;
                                    box-sizing: border-box;
                                }
                            }

                            .zhedie_con_body {
                                .itt {
                                    display: flex;
                                    align-items: center;
                                    padding: 12px 0;
                                    border-bottom: 1px solid #F0F0F0;

                                    p {
                                        flex: 1;
                                        font-family: PingFang SC, PingFang SC;
                                        font-weight: 400;
                                        font-size: 16px;
                                        color: #4A5676;
                                        line-height: 24px;
                                        padding: 0 6px;
                                        box-sizing: border-box;
                                    }
                                }
                            }
                        }
                    }
                    .slide{
                        .tem{
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-family: PingFang SC, PingFang SC;
                            font-weight: 400;
                            font-size: 16px;
                            color: #4A5676;
                            line-height: 24px;
                            padding: 8px 0 0 8px;
                            cursor: pointer;
                            img{
                                display: block;
                                width: 16px;
                                height: 16px;
                                margin-right: 4px;
                            }
                        }
                    }

                }

            }
        }
    }
</style>
